import QuoteDetatil from "./QuoteDetail";
export default QuoteDetatil;
